module.exports = __webpack_public_path__ + "static/img/18.0285e4c3.jpeg";